var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteUserNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(17.254902%,66.27451%,73.72549%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 18 15 L 21 18 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(17.254902%,66.27451%,73.72549%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 21 15 L 18 18 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "currentColor",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 16 8 C 16 10.761719 13.761719 13 11 13 C 8.238281 13 6 10.761719 6 8 C 6 5.238281 8.238281 3 11 3 C 13.761719 3 16 5.238281 16 8 Z M 16 8 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "currentColor",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 14 13.289062 C 13.351562 13.097656 12.675781 13 12 13 L 10 13 C 6.132812 13 3 16.132812 3 20 C 3 20.550781 3.449219 21 4 21 L 14 21 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUserNew);
export default __webpack_public_path__ + "static/media/delete-user-new.b880cffd3319de5901682e4f10562a0e.svg";
export { ForwardRef as ReactComponent };